const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = true;
const InitPageTest: number = 0;

const getPageInit = isDevelopment ? InitPageTest : 0;

const SiteConfig: ISiteConfig = {
    InitPage: getPageInit,
    TotalPage: 0,
    TotalPageBar: 7
} as ISiteConfig;


const AutoDataTemp: IAutoEmisionCR = {
    init: false,

    idPol: 0,
    idbrokerage: 0,
    insuredMail: '',
    insuredName: '',
    insuredPhonNumber: '',
    idPlan: 0,
    maxDayPlan: 0,
    currencyPlan: '',
    identification: '',
    typeDocument: '',
    vehicleNew: undefined,
    ente: 0,
    vehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',

    nationality: '',
    sex: '',
    birthdate: undefined,
    profession: '',
    company: '',
    monthlyIncome: '',
    companyPhone: '',
    frontIdentification: '',
    backIdentification: '',
    autoInsuranceStartDate: undefined,
    autoInsuranceExpirationDate: undefined,
    civilStatus: '',
    haveChildren: '',
    ownHouse: '',
    address: '',
    homePhone: '',
    countryOfOrigin: '',
    province: '',
    district: '',
    canton: '',
    ownVehicle: '',
    identificationFrontImage: undefined,
    identificationFrontImageIsModified: false,
    identificationBackImage: undefined,
    identificationBackImageIsModified: false,

    spouseName: '',
    spouseLastName: '',
    spouseBirthPlace: '',
    spouseBirthdate: undefined,
    spouseCountryOrigin: '',
    spouseProfession: '',
    spouseIdentificationType: '',
    spouseIdentification: '',
    spousePhoneNumber: '',

    obligatedSubjectsPEPQuestion1: '',
    obligatedSubjectsPEPQuestion2: '',
    cICACQuestion1: '',
    cICACReasonRejection: '',

    invoiceFile: undefined,
    specialEquipmentFile: undefined,
    vehiclePlate: '',
    vehicleEngine: '',
    vehicleTransmission: '',
    vehicleClass: '',
    vehicleDoorNumber: '',
    vehicleChasis: '',
    vehicleColor: '',
    vehicleCylinderNumber: '',
    vehicleFuel: '',
    vehicleDataLoading: false,

    frontCarImage: undefined,
    backCarImage: undefined,
    rightSideCarImage: undefined,
    leftSideCarImage: undefined,
    carPanelImage: undefined,

    accepTerm: false,

    totalBonus: 0,
    sumInsured: '',
    paymentFrequency: '',
    paymentFrequencyDetail: '',
    paymentFrequencyDetailStr: '',
    shippingMethod: '',
    feePay: '',
    cardName: '',
    cardNumber: '',
    cardExpirationDate: '',
    cardCVV: '',
    accepTermPV: false,

    statusAccount: '',
    transactionId: '',
    cnpoliza: '',

    acceptSaveCard: '',
    cardType: '',
    cardCountry: '',
    issuingBank: '',
    acceptCardTerm: false,

    catCountryOfOrigin: [],
    catNationality: [],
    catProfesion: [],
    catProvince: [],
    catDisctrict: [],
    catCanton: [],
    catVehicleTransmission: [],
    catVehicleClass: [],
    catVehicleDoorNumber: [],
    catvehicleCylinderNumber: [],
    catvehicleFuel: [],
    catBank: [],
    catInvalidRequirements: [],

    hasSpecialEquipment: false,
    isValidRecaptchaEvicertia: false,
    isValidRecaptchaPV: false,
    EvicertiaRejection: false,

    downloadReceipts: () => { },
    increment: () => { },
    downloadPolicy: () => { },
    sendNotificationEvicertia: () => { },
    getDataByPlate: () => { },
    issuePolice: () => { },

    emailBrokerage: '',
    usernameBrokerage: '',
    idBrokerage: 0,
    nameBrokerage: '',
}

const AutoWithDataTemp: IAutoEmisionCR = {
    init: false,

    idPol: 504066,
    idbrokerage: 0,
    insuredMail: 'eddortiz0591@hotmail.es',
    insuredName: 'Eddy Ortiz',
    insuredPhonNumber: '',
    idPlan: 0,
    maxDayPlan: 0,
    currencyPlan: '',
    identification: '',
    typeDocument: '',
    vehicleNew: undefined,
    ente: 0,
    vehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',

    nationality: '',
    sex: '',
    birthdate: undefined,
    profession: '',
    company: '',
    monthlyIncome: '',
    companyPhone: '',
    frontIdentification: '',
    backIdentification: '',
    autoInsuranceStartDate: undefined,
    autoInsuranceExpirationDate: undefined,
    civilStatus: '',
    haveChildren: '',
    ownHouse: '',
    address: '',
    homePhone: '',
    countryOfOrigin: '',
    province: '',
    district: '',
    canton: '',
    ownVehicle: '',
    identificationFrontImage: undefined,
    identificationFrontImageIsModified: false,
    identificationBackImage: undefined,
    identificationBackImageIsModified: false,

    spouseName: '',
    spouseLastName: '',
    spouseBirthPlace: '',
    spouseBirthdate: undefined,
    spouseCountryOrigin: '',
    spouseProfession: '',
    spouseIdentificationType: '',
    spouseIdentification: '',
    spousePhoneNumber: '',

    obligatedSubjectsPEPQuestion1: '',
    obligatedSubjectsPEPQuestion2: '',
    cICACQuestion1: '',
    cICACReasonRejection: '',

    invoiceFile: undefined,
    specialEquipmentFile: undefined,
    vehiclePlate: 'FHC085',
    vehicleEngine: '',
    vehicleTransmission: '',
    vehicleClass: '',
    vehicleDoorNumber: '',
    vehicleChasis: '',
    vehicleColor: '',
    vehicleCylinderNumber: '',
    vehicleFuel: '',
    vehicleDataLoading: false,

    frontCarImage: undefined,
    backCarImage: undefined,
    rightSideCarImage: undefined,
    leftSideCarImage: undefined,
    carPanelImage: undefined,

    accepTerm: false,

    totalBonus: 0,
    sumInsured: '',
    paymentFrequency: '',
    paymentFrequencyDetail: '',
    paymentFrequencyDetailStr: '',
    shippingMethod: '',
    feePay: '',
    cardName: 'EDDY ANTONIO ORTIZ',
    cardNumber: '4111111111111111',
    cardExpirationDate: '12/24',
    cardCVV: '',
    accepTermPV: false,

    statusAccount: '753073',
    //statusAccount: '',
    transactionId: '39207',
    cnpoliza: 'AU-176520-27570-0',

    acceptSaveCard: '',
    cardType: '',
    cardCountry: '',
    issuingBank: '',
    acceptCardTerm: false,

    catCountryOfOrigin: [],
    catNationality: [],
    catProfesion: [],
    catProvince: [],
    catDisctrict: [],
    catCanton: [],
    catVehicleTransmission: [],
    catVehicleClass: [],
    catVehicleDoorNumber: [],
    catvehicleCylinderNumber: [],
    catvehicleFuel: [],
    catBank: [],
    catInvalidRequirements: [],

    hasSpecialEquipment: false,
    isValidRecaptchaEvicertia: false,
    isValidRecaptchaPV: false,
    EvicertiaRejection: false,

    downloadReceipts: () => { },
    increment: () => { },
    downloadPolicy: () => { },
    sendNotificationEvicertia: () => { },
    getDataByPlate: () => { },
    issuePolice: () => { },

    emailBrokerage: '',
    usernameBrokerage: '',
    idBrokerage: 0,
    nameBrokerage: '',
}


const setObj = () => (setData && isDevelopment) ? ({ ...AutoWithDataTemp }) : ({ ...AutoDataTemp });

const AutoDefault: IAutoEmisionCR = setObj();

export { AutoDefault, SiteConfig };